var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-item"},[_c('OtInput',{attrs:{"type":"select","options":_vm.options,"value":_vm.selected,"placeholder":_vm.$t(
                'shop.components.option_product_group.select_item.placeholder'
            )},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }